<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<el-tabs v-model="activeName" type="card" :tab-position="'right'" @tab-click="handleClick"
			style="height: 100%;">
			<el-tab-pane v-for="(item,index) in list_mode" :key="index" :label="item.name" :name="item.mode">
				<component v-if="item.isActive" :is="NextTickName(item.mode)"></component>

			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import api from '@/utils/type.js'
	import {
		BackSpecial
	} from '@/utils/localstore.js';

	import {
		isPC
	} from '@/utils/method.js';

	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"tx_home_one": () => import("./home_page/home_one"),
			"tx_zhiri": () => import("./home_page/zhiri"),
			"tx_baoxian": () => import("./home_page/baoxian"),
			"tx_baoyue": () => import("./home_page/baoyue"),
			"tx_baoyang": () => import("./home_page/baoyang"),
			"tx_boss": () => import("./home_page/boss"),
			"tx_oil": () => import("./home_page/oil"),
			"tx_user": () => import("./home_page/user"),
			"tx_carlose": () => import("./home_page/carlose"),
			"tx_baoxiantwo": () => import("./home_page/baoxiantwo"),
			"tx_carViolation": () => import("./home_page/carViolation"),
			"tx_carguakao": () => import("./home_page/carguakao"),
			"tx_paysheetNo": () => import("./home_page/paysheet_no"),
			"tx_paysheet": () => import("./home_page/paysheet"),
			"tx_paysheet_sum": () => import("./home_page/paysheet_sum")
		},
		data() {
			return {
				element_loading: false,
				list_mode: [],
				activeName: '',



			};
		},
		created: function() {
			this.check_vasion();

		},
		mounted: function() {
			let that = this;
			this.$nextTick(function() {
				that.load_swich();
			})

		},
		methods: {
			check_vasion: function() {
				// console.log('检查版本号');
				isPC();

				this.$post(
					api.http_method,
					Method_EasySelect('sys_val_web_vasion')
				).then(res => {
					res = JSON.parse(res);
					if (res.data.status == 1) {
						console.log('取值001',res.data);
						let new_vasion = res.data.data[0].sys_val;
						let old_vasion = localStorage.getItem('vasion');
						// console.log('旧=' + old_vasion + ' 新=' + new_vasion)
						if (Number(new_vasion) != Number(old_vasion)) {
							localStorage.setItem('vasion', new_vasion);
							window.location.reload();
						}
					} else {
						this.$message({
							message: '没有待完成业务单号,原因:' + res.data.msg,
							type: 'warning'
						});
					}

				});

			},
			load_swich: function() {
				// console.log('加载配置模块');
				this.list_mode = [];
				this.$post(
					api.http_method,
					Method_EasySelect('data_homemode')
				).then(res => {
					res = JSON.parse(res);
					if (res.data.status == 1) {
						// console.log(res.data.data);
						let t = [];
						t = res.data.data;
						for (let i = 0; i < t.length; i++) {
							let o = {};
							o.isActive = false;
							o.mode = t[i].mode;
							o.name = t[i].name;
							this.list_mode.push(o);
						}
						// console.log(this.list_mode);



						this.activeName = this.list_mode[0].mode;
						this.list_mode[0].isActive = true;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}

				});
			},
			handleClick(tab) {
				// console.log(tab.name);
				this.activeName = '';
				this.activeName = tab.name;
				for (let i = 0; i < this.list_mode.length; i++) {

					if (this.list_mode[i].mode == tab.name) {
						console.log(this.list_mode[i]);
						this.list_mode[i].isActive = true;
					} else {
						this.list_mode[i].isActive = false;
					}
				}
			},
			NextTickName: function(key) {
				// console.log('key=' + key);
				return key;
			},




		}
	};
</script>
<style scoped>

</style>